import React, { useState, useEffect, useRef } from 'react'
import './admin.styles.scss'

import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'

import CreateEval from '@/components/ADMIN/create-eval/create-eval.component'
import Footer from '@/components/footer/footer.component'

import { useSelector, useDispatch } from 'react-redux'
// import { setEvalList } from '@/state/slices/listsSlice'

import { off } from "firebase/database";
import Header2025 from '../../components/header-2025/header-2025.component'
import ManageEvals from '../../components/ADMIN/manage-evals/manage-evals.component'
import AdminFunctions from '../../components/ADMIN/functions/admin-functions.component'
import EvalDataV2 from '../../components/ADMIN/eval-data/eval-data-v2.component'
import { getEvalListFromRtDb } from '../../utils/getDataFromDb'
import AdminUsers from '../../components/ADMIN/users/admin-users.component'
import AdminSidebar from './admin-sidebar.component'
import FormBuilder from '../../components/ADMIN/forms/form-builder.component'
import ManageQuestionSets from '../../components/SHARED/form-builder/manage-question-sets.component'
import { getCollectionFromFirestore } from '../../utils/getDataFromDbSimplified'
import CompiledData from '../../components/ADMIN/compiled-data/compiled-data.component'
import EvidenceCreator from '../../components/ADMIN/evidence-creator/evidence-creator.component'
import EvidenceList from '../../components/ADMIN/evidence-creator/evidence-list.component'
import EvidenceStateMap from '../../components/ADMIN/evidence-creator/evidence-state-map.component'

const AdminPage = () => {

  // const evalList = useSelector(state => state.listsData.evalList);
  const screenSize = useSelector(state => state.listsData.screenSize);
  const userProfile = useSelector(state => state.userData.userProfile);
  const [tabs, setTabs] = useState(null);
  const [evalList, setEvalList] = useState(null);
  const [questionSets, setQuestionSets] = useState({});
  const [source] = useState('none');
  const dataRef = useRef({});
  const setsRef = useRef({});
  const navigate = useNavigate();
  const location = useLocation();
  let evalListener;

  useEffect(() => {

    return () => {
      if (evalListener) off(evalListener);
    }
  }, [])

  useEffect(() => {
    if (location.pathname === '/admin' || location.pathname === '/admin/') {
      navigate('/admin/dashboard')
    }
  }, [location])

  useEffect(() => {
    // updateLists();
    getEvalsFromDB();
    const tabArr = [
      {
        'id': 'dashboard',
        'title': 'Data Dashboard',
        'href': '/admin/dashboard',
        'selected': 'not_selected'
      },
      {
        'id': 'download',
        'title': 'Compiled Data',
        'href': '/admin/compiled',
        'selected': 'not_selected'
      },
      {
        'id': 'manageEvals',
        'title': 'Manage Evaluations',
        'href': '/admin/evals',
        'selected': 'not_selected'
      },
      {
        'id': 'manageUsers',
        'title': 'Manage Users',
        'href': '/admin/users',
        'selected': 'not_selected'
      },
      {
        'id': 'createEvals',
        'title': 'Create an Evaluation',
        'href': '/admin/create',
        'selected': 'selected'
      },
      {
        'id': 'questionSets',
        'title': 'Question Sets',
        'href': '/admin/questionsets',
        'selected': 'not_selected'
      },
      {
        'id': 'evidenceCreator',
        'title': 'Evidence Creator',
        'href': '/admin/evidencecreator',
        'selected': 'not_selected'
      }

    ]
    if (userProfile && userProfile.email === 'adam.geisen@ilprincipals.org') {
      tabArr.push({
        'id': 'adminFunctions',
        'title': 'Admin Functions',
        'href': '/admin/functions',
        'selected': 'not_selected'
      });
    }
    setTabs(tabArr);
  }, [userProfile])

  const getEvalsFromDB = async (e) => {
    getEvalListFromRtDb({
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      console.log(data);
      if (data.status && data.status !== 'active') {
        const newEvals = {...dataRef.current};
        delete newEvals[data.id];
        dataRef.current = newEvals;
        setEvalList(dataRef.current);
        return;
      } else {
        dataRef.current = {
          ...dataRef.current,
          ...{ [data.id]: data }
        }
      }
      setEvalList(dataRef.current);
    }
    function handleListener(rtDocRef) {
      evalListener = rtDocRef;
    }

  }



  return (
    <div className={`admin_page ${screenSize}`}>
      <Header2025 tabs={tabs} source={source} />
      <div className='admin_content'>
        <div className={`admin_grid ${screenSize}`}>
          {
            (screenSize !== 'mobile' &&
              screenSize !== 'tablet') &&
            <AdminSidebar tabs={tabs} />
          }
          <div className='admin_main'>
            <Routes>
              <Route path='/create' element={
                <CreateEval />
              }></Route>
              <Route path='/evals/*' element={
                <ManageEvals evalList={evalList} />
              }></Route>
              <Route path='/users/*' element={
                <AdminUsers />
              }></Route>
              <Route path='/compiled' element={
                <CompiledData evalList={evalList} />
              }></Route>
              <Route path='/dashboard' element={
                <EvalDataV2 evalList={evalList} />
              }></Route>
              <Route path='/functions' element={
                <AdminFunctions />
              }></Route>
              <Route path='/questionsets/*' element={
                <FormBuilder />
              }></Route>
              <Route path='/evidencecreator' element={
                <EvidenceList />
              }></Route>
              <Route path='/evidencecreator/editor' element={
                <EvidenceCreator />
              }></Route>
              <Route path='/evidencecreator/statemap' element={
                <EvidenceStateMap />
              }></Route>
            </Routes>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default AdminPage